import { CapitalizeEachWord } from 'common/utils';

function getSubtypeTranslation(t, i18n, baseKey, subtype) {
  const rawSubtype = String(subtype || '');
  const normalizedSubtype = rawSubtype.toLowerCase();

  const exactKey = `${baseKey}.${rawSubtype}`;
  const normalizedKey = `${baseKey}.${normalizedSubtype}`;
  if (i18n && typeof i18n.exists === 'function' && i18n.exists(exactKey)) return t(exactKey);
  if (i18n && typeof i18n.exists === 'function' && i18n.exists(normalizedKey)) return t(normalizedKey);
  return CapitalizeEachWord(rawSubtype);
}

/**
 * Localized asset subtype label (template tabs, builder, etc.).
 *
 * @param {function} t - i18next `t`
 * @param {object} [i18n] - i18next instance (`exists` for key lookup)
 * @param {string} assetType - `rotating` | `non_rotating`
 * @param {string} subtype - API `sub_type`, e.g. `motors`, `steam_trap`
 * @returns {string}
 */
export function getAssetSubtypeDisplayName(t, i18n, assetType, subtype) {
  if (assetType === 'non_rotating') {
    return getSubtypeTranslation(t, i18n, 'assets.create.nonRotatingSubtypes', subtype);
  }
  if (assetType === 'rotating') {
    return getSubtypeTranslation(t, i18n, 'assets.create.rotatingSubtypes', subtype);
  }
  return CapitalizeEachWord(subtype);
}
